// horizontal scroller
document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".horizontal-scroller-main", {
    slidesPerView: "auto",
    spaceBetween: 0,
    freeMode: {
      enabled: true,
      momentum: false,
    },
    touchReleaseOnEdges: true,
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 0,
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
    mousewheel: {
      forceToAxis: true, // Prevents scroll hijacking
      releaseOnEdges: true, // Allows scrolling outside the section
    },
  });
});

// featured blog slider
var swiper = new Swiper(".blog_slider", {
    loop: false,       // No infinite loop
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination-blog-post",
        clickable: true,
    },
    autoplay: {
        delay: 5000, // Auto slide every 3 seconds
        disableOnInteraction: false, // Keeps autoplay active even after user interaction
    },
    breakpoints: {
        768: {  // For screens 768px and larger
            slidesPerView: 3,
            slidesPerGroup: 1,
            spaceBetween: 0,
        },
        0: {  // For screens smaller than 768px (mobile)
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 0,
        }
    }
});


// explore products size slider
const swiper2 = new Swiper('.explore_slider', {
  slidesPerView: 1,
  spaceBetween: 0,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 0,
    },
    992: {
      slidesPerView: 0, // Hide swiper on larger screens
    }
  }
});



document.addEventListener("DOMContentLoaded", function () {
function toggleImageVisibility(sectionId, imageId) {
  const targetSection = document.getElementById(sectionId);
  const image = document.getElementById(imageId);

  if (!targetSection || !image) return;

  const sectionBottom = targetSection.getBoundingClientRect().bottom;
  const viewportHeight = window.innerHeight;

  // Show image when the section's bottom is fully above the viewport bottom
  if (sectionBottom <= viewportHeight) {
    image.classList.add("visible");
  } else {
    image.classList.remove("visible");
  }
}

function checkAllSections() {
  // Call toggleImageVisibility for each section and its corresponding image
  toggleImageVisibility("cg_camera", "img_camera");
  toggleImageVisibility("cg_printer", "img_printer");
  toggleImageVisibility("cg_film", "img_film");
  toggleImageVisibility("cg_pal", "img_pal");
}

// Run on page scroll
window.addEventListener("scroll", checkAllSections);

// Run on page load to check initial positions
checkAllSections();
});





document.addEventListener("DOMContentLoaded", function () {
  function parallaxEffect() {
    document.querySelectorAll(".section_scroll_main").forEach((section) => {
      const image = section.querySelector(".fw_product_img");
      if (!image) return;

      const sectionRect = section.getBoundingClientRect();
      const sectionTop = sectionRect.top;
      const sectionHeight = sectionRect.height;

      // Start parallax effect when the section reaches the top of the viewport
      if (sectionTop <= 0 && sectionTop > -sectionHeight) {
        let offset = -sectionTop * 0.5; // Adjust multiplier for different speeds
        image.style.transform = `translateY(${offset}px)`;
      } else if (sectionTop > 0) {
        // Reset image position if section is below the top
        image.style.transform = `translateY(0px)`;
      }
    });
  }

  // Run on scroll
  window.addEventListener("scroll", parallaxEffect);

  // Run on page load to check initial positions
  parallaxEffect();
});


// Explore Products js start

// Explore Products tabs
document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll(".tab-button");
    const contents = document.querySelectorAll(".explore_products_tab_content");
    const carriage = document.querySelector(".carriage");

    function setActiveTab(button) {
        buttons.forEach(btn => btn.classList.remove("active"));
        contents.forEach(content => content.classList.remove("active"));
        
        button.classList.add("active");
        document.getElementById(button.dataset.target).classList.add("active");
        carriage.dataset.activeTab = button.dataset.target;
    }

    buttons.forEach(button => {
        button.addEventListener("click", function () {
            setActiveTab(this);
        });
    });

    // Ensure the first tab is active on page load
    const defaultActiveTab = document.querySelector(".tab-button.active");
    if (defaultActiveTab) {
        setActiveTab(defaultActiveTab);
    }
});
// Explore Products accordian
document.addEventListener("DOMContentLoaded", function () {
  const triggers = document.querySelectorAll(".accordian_trigger");

  triggers.forEach(trigger => {
      trigger.addEventListener("click", function () {
          const content = this.nextElementSibling;
          if (content.style.height === "0px" || !content.style.height) {
              content.style.height = content.scrollHeight + "px";
              content.classList.add("open");
          } else {
              content.style.height = "0px";
              content.classList.remove("open");
          }
          this.classList.toggle("open");
      });
  });
});
// Explore Products js end

document.addEventListener("DOMContentLoaded", function () {
  const continueBtns = document.querySelectorAll(".tab-button");
  const targetSection = document.querySelector(".explore_products_tabs_content_main");

  if (continueBtns.length > 0 && targetSection) {
    continueBtns.forEach((btn) => {
      btn.addEventListener("click", function (e) {
        e.preventDefault(); // Prevent default action if it's a link

        const offset = 150; // Stop 100px before the top
        const targetPosition = targetSection.getBoundingClientRect().top + window.scrollY - offset;
        const startPosition = window.scrollY;
        const distance = targetPosition - startPosition;
        const duration = 600; // Increase duration for slower scroll
        let startTime = null;

        function scrollAnimation(currentTime) {
          if (!startTime) startTime = currentTime;
          const timeElapsed = currentTime - startTime;
          const progress = Math.min(timeElapsed / duration, 1);

          // Smooth easing function
          window.scrollTo(0, startPosition + distance * easeInOutQuad(progress));

          if (timeElapsed < duration) {
            requestAnimationFrame(scrollAnimation);
          }
        }

        function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
        }

        requestAnimationFrame(scrollAnimation);
      });
    });
  }
});



    document.addEventListener("DOMContentLoaded", function() {
    const modal = document.getElementById("videoModal");
    const btn = document.getElementById("modal_btn");
    const span = document.querySelector("#videoModal .close");

    if (!modal || !btn) return;

    btn.onclick = function(e) {
        e.preventDefault();
        modal.style.display = "flex";
    };

    function closeModal() {
        modal.style.display = "none";

        const video = modal.querySelector(".modal-video");
        if (video) {
            video.pause();
            video.currentTime = 0;
        }
    }

    if (span) span.onclick = closeModal;
    window.onclick = function(event) {
        if (event.target === modal) {
            closeModal();
        }
    };
});





  document.addEventListener('DOMContentLoaded', function () {
    // Attach click listeners to all video buttons
    document.querySelectorAll('.feature_content_wrapper').forEach(function (sectionWrapper) {
      const modalBtn = sectionWrapper.querySelector('#sectiom_modal_btn');
      const sectionContainer = sectionWrapper.closest('.shopify-section');

      if (modalBtn && sectionContainer) {
        const modal = sectionContainer.querySelector('.section_modal');
        const closeBtn = modal?.querySelector('.section_close');

        modalBtn.addEventListener('click', function () {
          modal?.classList.add('active');
        });

        closeBtn?.addEventListener('click', function () {
          modal?.classList.remove('active');
        });

        // Close modal on outside click
        modal?.addEventListener('click', function (e) {
          if (e.target === modal) {
            modal.classList.remove('active');
          }
        });
      }
    });
  });








document.addEventListener("DOMContentLoaded", function () {
  const triggers = document.querySelectorAll(".ss-expand");

  triggers.forEach(trigger => {
    trigger.addEventListener("click", function () {
      const content = document.querySelector(".specifications_details-categories"); // global search
      if (!content) return;

      if (content.style.height === "0px" || !content.style.height) {
        content.style.height = content.scrollHeight + "px";
        content.classList.add("open");
      } else {
        content.style.height = "0px";
        content.classList.remove("open");
      }
      this.classList.toggle("open");
    });
  });
});



function toggleStickyOnScroll() {
  const scrollTop = window.scrollY || document.documentElement.scrollTop;
  const docHeight = document.documentElement.scrollHeight - window.innerHeight;
  const scrollPercent = scrollTop / docHeight;

  const element = document.getElementById('btt-mobile');
  
  if (!element) return; // If element does not exist, stop the function.

  if (scrollPercent >= 0.7) {
      element.classList.add('sticky');
  } else {
      element.classList.remove('sticky');
  }
}

window.addEventListener('scroll', toggleStickyOnScroll);





// Inspire me slider
var swiper = new Swiper(".inspire_me_slider", {
  loop: false,       // No infinite loop
  navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
  },
  pagination: {
      el: ".swiper-pagination",
      clickable: true,
  },
  autoplay: {
      delay: 5000, // Auto slide every 3 seconds
      disableOnInteraction: false, // Keeps autoplay active even after user interaction
  },
  breakpoints: {
      992: {  // For screens 768px and larger
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 0,
      },
      0: {  // For screens smaller than 768px (mobile)
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 0,
      }
  }
});
// Blog image slider slider
var swiper = new Swiper(".blog-image-slider", {
  loop: false,       // No infinite loop
  navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
  },
  pagination: {
      el: ".swiper-pagination",
      clickable: true,
  },
  autoplay: {
      delay: 5000, // Auto slide every 3 seconds
      disableOnInteraction: false, // Keeps autoplay active even after user interaction
  },
  breakpoints: {
      768: {  // For screens 768px and larger
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 0,
      },
      0: {  // For screens smaller than 768px (mobile)
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 0,
      }
  }
});






  document.addEventListener('DOMContentLoaded', function () {
    if(document.getElementById('contact-ribbon')) {
    const ribbonform = document.getElementById('contact-ribbon');
    const formSection = document.querySelector('.get-in-touch-form-main');
    let formInView = false;

    // Observe if the form is in view
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          formInView = entry.isIntersecting;
          if (formInView) {
            ribbonform.classList.remove('active');
          }
        });
      },
      { threshold: 0.1 } // Trigger when at least 10% of form is visible
    );

    if (formSection) {
      observer.observe(formSection);
    }

    // Scroll logic to add "active" if scrolled more than 20% of page
    window.addEventListener('scroll', () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = (scrollTop / docHeight) * 100;

      if (scrollPercent > 20 && !formInView) {
        ribbonform.classList.add('active');
      } else {
        ribbonform.classList.remove('active');
      }
    });
    }
  });




  document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementById("search_modal")) {
    const openModalsearchBtn = document.getElementById("search_modal");
    const searchmodal = document.querySelector(".modal");
    const closesearchModalBtn = searchmodal.querySelector(".close");
    openModalsearchBtn.addEventListener("click", function (e) {
      e.preventDefault();
      searchmodal.style.display = "block";
    });
    closesearchModalBtn.addEventListener("click", function () {
      searchmodal.style.display = "none";
    });
    window.addEventListener("click", function (e) {
      if (e.target === searchmodal) {
        searchmodal.style.display = "none";
      }
    });
    }
  });


  if(document.querySelector('.faq-button')){
  const faqButton = document.querySelector('.faq-button');
  const faqGroup = document.getElementById('instax-up-faq-group');
  const faqAnswers = document.querySelectorAll('.instax-up-faq-a');
  
  // Toggle full FAQ section
  faqButton.addEventListener('click', function () {
    const isOpen = faqGroup.style.maxHeight && faqGroup.style.maxHeight !== '0px';
  
    // Always remove no-transition before changing height
    faqGroup.classList.remove('no-transition');
  
    if (isOpen) {
      // COLLAPSE
      faqGroup.style.maxHeight = faqGroup.scrollHeight + 'px'; // Set current height first
      // Force reflow to apply the style above before collapsing
      faqGroup.offsetHeight;
      faqGroup.style.maxHeight = '0px';
  
      // After animation, cleanup
      setTimeout(() => {
        faqGroup.style.maxHeight = null;
      }, 500); // match transition time
    } else {
      // EXPAND
      faqGroup.style.maxHeight = faqGroup.scrollHeight + 'px';
  
      // After opening, lock height to "none" to avoid conflict when toggling inner answers
      setTimeout(() => {
        faqGroup.classList.add('no-transition');
        faqGroup.style.maxHeight = 'none';
      }, 500);
    }
  
    this.classList.toggle('faqs-open');
  
  });
  }
  // Toggle individual FAQ answers
  document.querySelectorAll('.instax-up-faq-q').forEach(question => {
    question.addEventListener('click', function () {
      const faqItem = this.closest('.instax-up-faq');
      const answer = faqItem.querySelector('.instax-up-faq-a');
  
      faqItem.classList.toggle('instax-up-faq-open');
  
      if (answer.style.maxHeight && answer.style.maxHeight !== '0px') {
        answer.style.maxHeight = '0px';
      } else {
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
  
      // Allow the outer container to resize freely without transition
      faqGroup.classList.add('no-transition');
      faqGroup.style.maxHeight = 'none';
    });
  });
  
  
  document.querySelectorAll('.connect_tabs_heading').forEach(heading => {
    heading.addEventListener('click', function () {
      const content = this.nextElementSibling;
  
      if (content.style.maxHeight && content.style.maxHeight !== '0px') {
        // Collapse
        content.style.maxHeight = '0px';
      } else {
        // Expand
        content.style.maxHeight = content.scrollHeight + 'px';
  
        // Optionally reset to 'none' after animation for smoother resize (optional)
        setTimeout(() => {
          content.style.maxHeight = 'none';
        }, 400); // match transition duration
      }
    });
  });
  // Remove "none" if set from previous open
  if (content.style.maxHeight === 'none') {
    content.style.maxHeight = '0px';
    content.offsetHeight; // force reflow
  }